export const socialData = {
    EMAIL: "mailto:alikonuk1@protonmail.com",
    TWITTER: "https://x.com/slot1024_eth",
    GITHUB: "https://github.com/alikonuk1/eth-tools",
  };